<template>
    <div class="overflow-x-hidden">
        <section class="video-section grid flex flex-wrap justify-content-center align-items-center">
            <div class="hero-section relative overflow-hidden shadow-4 col-12 ">
                <div v-if="!videoLoaded" class="loading-placeholder flex align-items-center justify-content-center">
                    <div class="loading-content text-center">
                        <i class="pi pi-spin pi-spinner text-4xl text-white mb-3"></i>
                        <p class="text-white">Loading...</p>
                    </div>
                </div>
                <video v-if="vedioUrl" id="heroVideo" autoplay muted loop playsinline preload="auto" class="hero-video"
                    :class="{ 'hidden': !videoLoaded }" @loadeddata="videoLoaded = true" @canplay="videoLoaded = true">
                    <source :src="vedioUrl" type="video/mp4" />
                </video>
                <div class="overlay-content text-center px-3">
                    <h1 class="LandingPage-Title  mb-3">
                        Learn, Teach, and Grow — The Island Way
                    </h1>
                    <p class="Paragraph-Medium md:px-8 mb-4">
                        Our one-stop platform to connect students with qualified tutors across Sri Lanka.
                        Search, book, and learn from verified tutors.
                    </p>
                </div>
                <!-- <div class="text-center overlay-button">
                    <Button icon="pi pi-play" class="p-button-rounded p-button-outlined p-button-lg text-white" />
                </div> -->

            </div>
        </section>
    </div>
</template>
<script setup>
// import Button from 'primevue/button';
import { usePublicUrl } from "@/utils/getPublicUrl"
import { ref } from 'vue';

const vedioUrl = usePublicUrl("public/home.mp4");
const videoLoaded = ref(false);
//  if (Hls.isSupported()) {
//     const video = document.getElementById('heroVideo');
//     const hls = new Hls();
//     hls.loadSource('home.m3u8');
//     hls.attachMedia(video);
//   }
</script>
<style scoped>
.loading-placeholder {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--gray-700);
    z-index: 2;
}

.hidden {
    display: none;
}

.hero-section {
    position: relative;
    overflow: hidden;
    height: 650px;
}

.hero-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.overlay-content {
    position: absolute;
    top: 20%;
    left: 50%;
    /* transform: translate(-10%, -120%); */
    max-width: 800px;
    /* width: 90%; */
}

.overlay-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 800px;
}

/* Responsive Styles */
@media (max-width: 768px) {
    .hero-section {
        height: 400px;
    }
    .overlay-content {
        top: 30%;
        left: 0;
    }

    .overlay-content h1 {
        font-size: 1.5rem;
    }

    .overlay-content p {
        font-size: 0.9rem;
    }
}


</style>